import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPageVariableMapData, updatePageVariableMapData } from "../../../slices/panelSlice/pageAndVariableSlice";
import Pagination from '../../../components/Pagination';
import Loader from '../../../components/Loader';
import EditableTable from "../PageAndVariable/PageAndVarTable";
import Modal from "../../../components/Modal"
import ChangeLog from "../../../components/ChangeLog";
import Swal from "sweetalert2";
import api from "../../../auth/api";
import { alertSuccess } from "../../../components/Alert";


function VariableSubCategory({editable}) {
  const dispatch = useDispatch();
  const { data, status, error } = useSelector((state) => state.pageAndVariable);
  const { pageHeaderData} = useSelector((state) => state.pageHeader);
  const {variableList} = useSelector((state)=>state.variableList);

  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(data?.result) ? data?.result?.slice(indexOfFirstItem, indexOfLastItem) : [];
  const totalPages = Array.isArray(data?.result) ? Math.ceil(data?.result?.length / itemsPerPage) : 0;
  const headers = data?.result?.length > 0 ? Object.keys(data.result[0]).filter((key) => key !== 'id') : [];
  const editableFields = ['title','pagetitle','variable','VariableIndex']; // Define editable fields

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog,setCurrentLog] = useState([]);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    dispatch(fetchPageVariableMapData());
  }, [dispatch]);

  if (status === "loading") {
    return (
      <div className="pt-12">
        <Loader />
      </div>
    );
  }

  // if (status === "failed") {
  //   return <div>Error: {error}</div>;
  // }

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = data.result.find((user) => user.id === rowId);
    setEditedData(rowData);
  };


  const handleSave = async () => {
    console.log(editedData)
    const { id, title, pagetitle, variable, VariableIndex } = editedData;
    const pageTitleId = pageHeaderData?.result?.filter(f=>f.title===pagetitle)[0].id;
    const variableId = variableList?.QuestionList?.filter(f=>f.title===variable)[0].id;
    const updatedData = { id, title, VariableIndex, pagetitle:pageTitleId, variable:variableId };
    console.log(updatedData)
    const resp = await dispatch(updatePageVariableMapData(updatedData));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchPageVariableMapData());
    }
  };

  const handlePageAddVariable = () => {
    Swal.fire({
      title: "Add Page & Variable",
      html: `
      <div>
        <input id="title" class="swal2-input" placeholder="Title">
        <input id="variableIndex" class="swal2-input" placeholder="Variable Index">
<br/>
        <select id="variable" class="swal2-input border border-[#d9d9d9] focus:border-[#b1cae3] focus:[border-width:2px]  outline-none" ring-8 focus:ring>
        <option value="0" disabled selected >Variable</option>
          ${variableList?.QuestionList.map(
            (option) => `<option value="${option.id}">${option.title}</option>`
          ).join("")}
        </select>

              <select id="pageTitle" class="swal2-input min-w-fit border border-[#d9d9d9] focus:border-[#b1cae3] focus:[border-width:2px]  outline-none" ring-8 focus:ring>
        <option value="0" disabled selected >Page Header</option>
          ${pageHeaderData?.result.map(
            (option) => `<option value="${option.id}">${option.title}</option>`
          ).join("")}
        </select>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Add",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const title = document.getElementById("title").value.trim();
        const pageTitle = document.getElementById("pageTitle").value.trim();
        const variable = document.getElementById("variable").value.trim();
        const variableIndex = document.getElementById("variableIndex").value;
    
        // Validation for inputs
        if (!title) {
          Swal.showValidationMessage("Title is required!");
          return;
        }
        if (title.length < 3) {
          Swal.showValidationMessage("Title must be at least 3 characters long!");
          return;
        }
        if (!/^[a-zA-Z0-9\s]+$/.test(title)) {
          Swal.showValidationMessage("Title can only contain letters, numbers, and spaces!");
          return;
        }

        if (!pageTitle) {
          Swal.showValidationMessage("Page title is required!");
          return;
        }

        if (!variable) {
          Swal.showValidationMessage("Variable is required!");
          return;
        }
        if (!variableIndex) {
          Swal.showValidationMessage("variable Index is required!");
          return;
        }
    
        try {
          const response = await api.post("/panel/pagePanelMap", {
            "title":title,
            "pagetitle":pageTitle,
            "variable":variable,
            "index":variableIndex
        });
          alertSuccess("Page Variable added successfully.");
          dispatch(fetchPageVariableMapData());
        } catch (error) {
          console.error(error);
          Swal.showValidationMessage(
            error.response?.data?.errors || error.message
          );
        }
      },
      allowOutsideClick: false,
    });
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field,val) => {
      if(field==="active"){
        setEditedData((prev) => ({
          ...prev,
          [field]:!val,
        }));
      }else{
        setEditedData((prev) => ({
          ...prev,
          [field]:e.target.value,
        }));
      }
  };

  const handleLog = (id)=>{
    const logData = data.Change_Log.filter((f)=>f.id===id)[0]?.oldTrack;
    setCurrentLog(logData)
    openModal()
  }

  return (
    <div className="w-full flex items-center flex-col">

      <EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        handleChange={handleChange}
        handleLog={handleLog}
        editableFields={editableFields} // Pass editable fields
        editable={editable}
      />
      
  

<div className="flex mt-4 items-center justify-between w-11/12">
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />

      {editable && 
                <button className="activeBtn text-sm text-white  py-1 px-2 rounded" onClick={handlePageAddVariable}>
            + Add Page and Variable
          </button>
      }

          </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog}/>}
      />
    </div>
  );
}

export default VariableSubCategory